import { render, staticRenderFns } from "./ReportHistoryNew.vue?vue&type=template&id=5fec2822&scoped=true&"
import script from "./ReportHistoryNew.vue?vue&type=script&lang=js&"
export * from "./ReportHistoryNew.vue?vue&type=script&lang=js&"
import style0 from "./ReportHistoryNew.vue?vue&type=style&index=0&id=5fec2822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fec2822",
  null
  
)

export default component.exports